import { render, staticRenderFns } from "./PageVehicleList.vue?vue&type=template&id=36fcf059"
import script from "./PageVehicleList.vue?vue&type=script&lang=js"
export * from "./PageVehicleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports